import React from 'react';

const MENU_FILLER_ID = '__FILLER__';

interface Props {
    id: string;
    cssKey: string;
    IconComponent: React.ComponentType;
    iconComponentProps: any;
    isEnabled: boolean;
    columns: number;
    onChange?: (evt: React.MouseEvent) => void;
}
export default class QuickNavItem extends React.PureComponent<Props> {
    static defaultProps = {
        isEnabled: true,
        columns: 1,
        iconComponentProps: {},
    };

    renderButton = (): React.ReactNode => {
        const { children, IconComponent, iconComponentProps, onChange, isEnabled } = this.props;

        let classNames: Array<string> = ['ct-quick-nav__button'];
        if (!isEnabled) {
            classNames.push('ct-quick-nav__button--disabled');
        }

        return (
            <div className={classNames.join(' ')} onClick={isEnabled ? onChange : undefined}>
                {IconComponent && (
                    <div className="ct-quick-nav__button-icon">
                        <IconComponent {...iconComponentProps} />
                    </div>
                )}
                <div className="ct-quick-nav__button-label">{children}</div>
            </div>
        );
    };

    render() {
        const { id, cssKey, columns, isEnabled } = this.props;

        if (id === MENU_FILLER_ID) {
            return <div className="ct-quick-nav__menu-item ct-quick-nav__menu-item--filler" />;
        }

        let classNames: Array<string> = [
            'ct-quick-nav__menu-item',
            `ct-quick-nav__menu-item--${cssKey}`,
            `ct-quick-nav__menu-item--cols-${columns}`,
        ];
        if (!isEnabled) {
            classNames.push('ct-quick-nav__menu-item--disabled');
        }

        return <div className={classNames.join(' ')}>{this.renderButton()}</div>;
    }
}
